import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={12} height={7} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M6 4.784L10.348.436a.822.822 0 011.161 1.162L6.581 6.527c-.321.32-.841.32-1.162 0l-4.93-4.93A.821.821 0 111.653.437L6 4.784z" fill="#fff" /></svg>;
}
export default SvgComponent;